export default __webpack_public_path__ + "static/media/videos.bbf90277.svg";